import React, { Component, ErrorInfo } from 'react'

import * as InternalBlockContent from '@sanity/block-content-to-react'
import { normalizePortableText } from 'src/utils/normalizePortableText'

interface BlockBoundaryProps {
  children: React.ReactNode
  fallback: React.ReactNode
}

interface State {
  failure: boolean
}

class BlockBoundary extends Component<BlockBoundaryProps, State> {
  constructor(props: BlockBoundaryProps) {
    super(props)
    this.state = { failure: false }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Module failure caught due to error: ', error, errorInfo)
    this.setState({ failure: true })
  }

  render() {
    const { state, props } = this
    if (state.failure) {
      return props.fallback
    }

    return props.children
  }
}

export type BlockContentProps = {
  blocks: any[]
  serializers?: any
}

const BlockContent = (props: BlockContentProps): React.ReactElement => {
  const { blocks, serializers } = props
  const _blocks = normalizePortableText(blocks)

  return (
    <BlockBoundary fallback={<p>Something went wrong</p>}>
      <InternalBlockContent blocks={_blocks} serializers={serializers} />
    </BlockBoundary>
  )
}

export default BlockContent
